import { SanitizationOption } from 'app/utils/htmlSanitizer/types';

export const SANITIZE_PROFILE_HIGHLIGHT: SanitizationOption = {
  allowedTags: ['em'],
  allowedClasses: {
    em: ['highlight'],
  },
};
